export default __webpack_public_path__ + "static/media/backArrow.bd591ae5.svg";